import type { ReactNode } from 'react';
import { Box, Flex } from '@customerio/pluma-components/react';
import { SidebarHeader } from './sidebar-header';
import * as styles from './sidebar-panel.css';

type SidebarPanelProps = {
  title: ReactNode;
  onClose: () => void;
  isCloseDisabled?: boolean;
  footer: ReactNode;
  children: ReactNode;
  [dataAttribute: `data-${string}`]: boolean | string | undefined;
};

export function SidebarPanel({
  title,
  onClose,
  isCloseDisabled,
  footer,
  children,
  ...dataAttributes
}: SidebarPanelProps) {
  return (
    <Box className={styles.panel} data-testid="sidebar-panel" {...dataAttributes}>
      <SidebarHeader title={title} onClose={onClose} isCloseDisabled={isCloseDisabled} />
      <Box className={styles.body}>{children}</Box>
      <Flex className={styles.footer} justifyContent="flex-end" gap="200">
        {footer}
      </Flex>
    </Box>
  );
}
